import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import './Chart.css';

const OrderStatusChart: React.FC = () => {
  const data = [
    { name: 'Completed', value: 65, color: '#4ecdc4' },
    { name: 'Processing', value: 20, color: '#ffa726' },
    { name: 'Pending', value: 10, color: '#42a5f5' },
    { name: 'Failed', value: 5, color: '#ef5350' },
  ];

  return (
    <div className="chart-card">
      <div className="chart-header">
        <div>
          <h3 className="chart-title">Order Status</h3>
          <p className="chart-subtitle">Today's order breakdown</p>
        </div>
      </div>
      <div className="chart-content">
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              paddingAngle={5}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default OrderStatusChart;

